/**
 * @name COPYRIGHT
 * @description
 * The COPYRIGHT constant is used to display the copyright
 * text in the footer of the application.
 * @example
 */
export const copyrightText = `© ${new Date().getFullYear()}, Skade`;
